import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./homeStyle.css";
import AOS from "aos";
import "aos/dist/aos.css";
import {parseISO, differenceInCalendarDays, isToday} from 'date-fns';

import { IoMusicalNotes } from "react-icons/io5";
import { FaLightbulb } from "react-icons/fa6";
import { MdSpeaker } from "react-icons/md";
import { IoMdBuild } from "react-icons/io";
import { GiPartyFlags, GiMicrophone } from "react-icons/gi";

export default function Home() {
    const navigate = useNavigate();

    const [nextEvent, setNextEvent] = useState(null);
    const rotatingTexts = [
        "Bist du bereit für dein unvergessliches Event?",
        "Bist du bereit für dein unvergessliches Event?",
        "Bist du bereit für dein unvergessliches Event?",
        //"Wir sorgen für Licht, Ton und Stimmung",
        //"Frage jetzt bei uns an und lass uns gemeinsam dein Event planen",
    ];
    const [rotIndex, setRotIndex] = useState(0);

    useEffect(() => {
        document.title = "DJ - EMAN"
        AOS.init({
            duration: 1000,
            once: false
        });

        getNextEvent();
    }, []);

    useEffect(() => {
        const interval = setInterval(() => {
            setRotIndex(i => (i + 1) % rotatingTexts.length);
        }, 5000);

        return () => clearInterval(interval);
    }, []);

    const getNextEvent = async (e) => {
        try {
            const response = await fetch("https://djeman.de:8443/api/v1/nextevent", {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                }
            });

            if (response.status == 200) {
                setNextEvent(await response.json());
            }
        } catch (error) {
            console.error("Fehler beim API Request: ", error);
        }
    }

    const nextEventText = (eventDateString) => {
        const eventDate = parseISO(eventDateString);
        const today = new Date();

        const daysDiff = differenceInCalendarDays(eventDate, today);

        let message = '';
        if (isToday(eventDate)) {
            message = "Nächstes Event Heute";
        } else if (daysDiff === 1) {
            message = "Nächstes Event Morgen";
        } else if (daysDiff > 1) {
            message = `Nächstes Event in ${daysDiff} Tagen`;
        } else {
            message = "Keine anstehenden Events";
        }

        return <h1>{message}</h1>;
    }

    function dateFormatter(date) {
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = d.getFullYear();
        const hours = String(d.getHours()).padStart(2, '0');
        const minutes = String(d.getMinutes()).padStart(2, '0');

        return `${day}.${month}.${year} ${hours}:${minutes} Uhr`;
    }

    function switchSide(side) {
        navigate(side);
    }

    function isEasterPeriod() {
        const today = new Date();

        return today.getMonth() === 3 && today.getDate() >= 1 && today.getDate <= 15;
    }

    function isChristmasPeriod() {
        const today = new Date();

        return today.getMonth() === 11 && today.getDate() >= 1 && today.getDate <= 31;
    }

    return (
        <div className="mainContainer">
            <div className="welcomeContainer">
                <div className="background"></div>
                <div className="textContent">
                    <img data-aos="fade-right" src={isEasterPeriod ? "/img/logo_ostern.png" : isChristmasPeriod ? "/img/logo_weihnachten.png" : "/img/logo.png"} />
                    <p data-aos="fade-left">Licht • Ton • Bühne</p>
                    <h2 data-aos="fade-right" aria-live="polite">{rotatingTexts[rotIndex]}</h2>
                </div>
                {nextEvent && (
                    <div className="nextEventContainer" onClick={() => switchSide("/events")}>
                        <h1>{nextEventText(nextEvent.date)}</h1>
                        <h2>{nextEvent ? nextEvent.title : ""}</h2>
                        <div className="dateAndLocationContainer">
                            <div>
                                <h3>Wann?</h3>
                                <h4>{nextEvent ? dateFormatter(nextEvent.date) : ""}</h4>
                            </div>
                            <div className="locationPartContainer">
                                <h3>Wo?</h3>
                                <h4>{nextEvent ? nextEvent.location : ""}</h4>
                            </div>
                        </div>
                    </div>
                )}
            </div>
            <div className="shortDescriptionContainer">
                <h1>Übersicht der Dienstleistungen</h1>
                <div className="dienstleistungen">
                    <div className="dienstleistungsContainer" onClick={() => switchSide("/music")}>
                        <div className="rowContainer">
                            <IoMusicalNotes className="icon" />
                            <h1>Musik</h1>
                        </div>
                        <h2>Egal ob 90er, 2000er, Neues über Techno | Für jedes Event ist die passende Musik vorhanden</h2>
                    </div>
                    <div className="dienstleistungsContainer" onClick={() => switchSide("/technik")}>
                        <div className="rowContainer">
                            <FaLightbulb className="icon" />
                            <h1>Licht</h1>
                        </div>
                        <h2>Events in aller größenordnung kann mit moderner LED und bewegungstechnik ausgestattet werden</h2>
                    </div>
                    <div className="dienstleistungsContainer" onClick={() => switchSide("/technik")}>
                        <div className="rowContainer">
                            <MdSpeaker className="icon" />
                            <h1>Ton</h1>
                        </div>
                        <h2>Mit hochwertiger und perfekt abgestimmter Tontechnik wird für satten Sound gesorgt</h2>
                    </div>
                    <div className="dienstleistungsContainer" onClick={() => switchSide("/technik")}>
                        <div className="rowContainer">
                            <IoMdBuild className="icon" />
                            <h1>Bühne</h1>
                        </div>
                        <h2>Individuelle Bühnenlösungen für jede Produktion | Stabil, sicher und ordentlich</h2>
                    </div>
                    <div className="dienstleistungsContainer" onClick={() => switchSide("/technik")}>
                        <div className="rowContainer">
                            <GiPartyFlags className="icon" />
                            <h1>Ambiente</h1>
                        </div>
                        <h2>Wir statten eure Eventlocation mit Kraftvollem Ambientelicht aus</h2>
                    </div>
                    <div className="dienstleistungsContainer" onClick={() => switchSide("/technik")}>
                        <div className="rowContainer">
                            <GiMicrophone className="icon" />
                            <h1>Band Support</h1>
                        </div>
                        <h2>Wir statten euren Band Auftritt aus und übernehmen das Operation von Licht</h2>
                    </div>
                </div>
            </div>
            <div className="locationContainer">
                <div className="background2" />
                <h1>Der Weg zu deinem Event</h1>
                <h2>Aller Anfang ist schwer doch wir erleichtern dir die Planung. Hier die Schritte zu deinem
                    Event:</h2>
                <h3><span className="orange">1.</span> Stelle eine <u><span onClick={() => navigate("/anfrage")}>Anfrage</span></u> und beschreibe
                    deine größe des Events sowie die erwartete Personenanzahl</h3>
                <h3><span className="orange">2.</span> Wir setzten uns mit Ihnen Telefonisch oder Persönlich zusammen
                    und besprechen Musikwünsche und Bühnenaufbauten</h3>
                <h3><span className="orange">3.</span> Am Aufbautag (Oft 1 Tag zuvor) werden Bühne, Lich und Ton installiert damit an Ihrem Eventtag alles glatt läuft. Die Anfahrt geschieht je nach Eventgröße mit einem LKW</h3>
                <h3><span className="orange">4.</span> Die Technik wird nach absprache entweder in der Eventnacht oder am nächsten Vormittag abgebaut & abgeholt</h3>
            </div>
        </div>
    )
}
